import type { JSX } from 'solid-js';
import { Show, splitProps } from 'solid-js';
import { classNames } from '../lib/classes';

export type Tone = 'neutral' | 'warn' | 'bad' | 'tier-1' | 'tier-2' | 'tier-4';

const TONE_CLASSES: Record<Tone, string> = {
  neutral: 'bg-tea-50 border-border text-fg',
  warn: 'bg-amber-50 border-amber-300 text-warn',
  bad: 'bg-rose-50 border-rose-300 text-bad',
  'tier-1': 'bg-lime-100 border-lime-400 text-lime-800',
  'tier-2': 'bg-emerald-100 border-emerald-400 text-emerald-800',
  'tier-4': 'bg-violet-100 border-violet-400 text-violet-800',
};

const BASE_CLASSES =
  'inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-xs';

type Props = JSX.HTMLAttributes<HTMLSpanElement> & {
  tone?: Tone;
  href?: string;
  title?: string;
};

export function Chip(props: Props) {
  const [local, rest] = splitProps(props, [
    'class',
    'tone',
    'children',
    'href',
  ]);
  return (
    <Show
      when={local.href}
      fallback={
        <span
          class={classNames(
            BASE_CLASSES,
            TONE_CLASSES[local.tone ?? 'neutral'],
            local.class,
          )}
          {...rest}
        >
          {local.children}
        </span>
      }
    >
      <a
        href={local.href}
        target="_blank"
        rel="noopener noreferrer"
        class={classNames(
          BASE_CLASSES,
          TONE_CLASSES[local.tone ?? 'neutral'],
          'underline-offset-2 hover:underline',
          local.class,
        )}
        {...(rest as JSX.AnchorHTMLAttributes<HTMLAnchorElement>)}
      >
        {local.children}
      </a>
    </Show>
  );
}
